import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface AdminSetupGuideNavItemProps {
  title: ReactNode;
  isActive: boolean;
  isCompleted?: boolean;
  onClick: () => void;
}

/*
 * Style.
 */

const StyledButton = styled(ChromelessButton)<{$isActive: boolean}>`
  display: flex;
  height: 32px;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  background-color: ${(p) => (p.$isActive ? p.theme.palette.blue.shade40 : 'transparent')};

  &:hover {
    background-color: ${(p) => (p.$isActive ? p.theme.palette.blue.shade40 : p.theme.alphas.gray10)};
  }
`;

const StyledTitleDiv = styled.div<{$isActive: boolean}>`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.bold};
  line-height: 118.75%;
  color: ${(p) => (p.$isActive ? p.theme.greys.white : p.theme.greys.shade90)};
`;

const StyledIconContainerDiv = styled.div`
  /* Dimensions are slightly smaller than the icon to avoid bleeding out */
  height: 13px;
  width: 13px;
  border-radius: 99px;
  background-color: ${(p) => p.theme.greys.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledCompletedIcon = styled(Icon)`
  height: 16px;
  width: 16px;
  color: ${(p) => p.theme.palette.green.shade40};
`;

/*
 * Component.
 */

export const AdminSetupGuideNavItem: FC<AdminSetupGuideNavItemProps> = (props) => (
  <StyledButton $isActive={props.isActive} onClick={props.onClick}>
    <StyledTitleDiv $isActive={props.isActive}>{props.title}</StyledTitleDiv>
    {props.isCompleted && (
      <StyledIconContainerDiv>
        <StyledCompletedIcon name="checkmarkCircleSmall" />
      </StyledIconContainerDiv>
    )}
  </StyledButton>
);
